import { createSelector } from 'reselect'

const getCreatedVendor = ({ searchVendor }) => searchVendor.createdVendor
const getCreatingVendor = ({ searchVendor }) => searchVendor.creating
const getSearchingVendors = ({ searchVendor }) => searchVendor.loading
const getVendorSearchResults = ({ searchVendor }) => searchVendor.records

const mapVendorFields = ({ merchantCategory, ...merchant }) => ({
  label: merchant.name,
  value: {
    ...merchant,
    category: { ...merchantCategory, expenseCategory: merchant.mappedCategory.value },
  },
})

const searchVendorSelectors = {
  getCreatedVendor: createSelector([getCreatedVendor], (createdVendor) => {
    if (!createdVendor || !Object.keys(createdVendor).length) {
      return {}
    }
    return mapVendorFields(createdVendor)
  }),
  getCreatingVendor: createSelector([getCreatingVendor], (creatingVendor) => {
    return creatingVendor
  }),
  getVendorSearchResults: createSelector([getVendorSearchResults], (results) => {
    if (!results) {
      return []
    }
    return results.map(mapVendorFields)
  }),
  getSearchingVendors: createSelector([getSearchingVendors], (searchingVendors) => {
    return searchingVendors
  }),
}

export default searchVendorSelectors
